import 'react';
import clsx from 'clsx';
import { Alert, Text } from 'reaxl';
import { jsxs } from 'react/jsx-runtime';
function WalletServicesErrorAlert() {
  let {
    className,
    isSavingError = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/jsxs(Alert, {
    "data-cmp": "wallet-payment-calc-error-alert",
    className: clsx('text-size-400', className),
    bsStyle: "danger",
    children: [/*#__PURE__*/jsxs(Text, {
      weight: "bold",
      children: ["Whoops! We experienced an issue\xA0", isSavingError ? 'with saving your changes' : 'on our side', "."]
    }), "\xA0Please try again."]
  });
}
export { WalletServicesErrorAlert as default };
